import { render, staticRenderFns } from "./OContents.vue?vue&type=template&id=03689262&scoped=true&"
import script from "./OContents.vue?vue&type=script&lang=ts&"
export * from "./OContents.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03689262",
  null
  
)

export default component.exports